import { render, staticRenderFns } from "./StoragesViewInfoCards.vue?vue&type=template&id=13a83b50&lang=true"
import script from "./StoragesViewInfoCards.vue?vue&type=script&lang=js"
export * from "./StoragesViewInfoCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports